import React from 'react'
import styled from '@emotion/styled'
import { Box } from '@mui/material'
import { SxProps } from '@mui/material'
import circlesOrbitColorPalette from 'common/ui/circlesColorTheme'

const StyledColorBox = styled(Box)({
  backgroundColor: circlesOrbitColorPalette.neutrals.background2,
  padding: '1vh 4vh',
  borderRadius: '8px',
  marginTop: '1vh'
})

interface ColorBoxProps {
  children: React.ReactNode
  sx?: SxProps
}

const ColorBoxInfoVendor = (props: ColorBoxProps) => {
  const { children, sx } = props
  return <StyledColorBox sx={sx}>{children}</StyledColorBox>
}

export default ColorBoxInfoVendor
